<script lang="ts">
  import type { Snippet } from 'svelte';
  interface Props {
    title?: string;
    subtitle?: string;
    padded?: boolean;
    class?: string;
    actions?: Snippet;
    children: Snippet;
    footer?: Snippet;
  }
  let { title, subtitle, padded = true, class: cls = '', actions, children, footer }: Props = $props();
</script>

<section class="card {cls}">
  {#if title || actions}
    <header class="card-header">
      <div class="titles">
        {#if title}<h3 class="card-title">{title}</h3>{/if}
        {#if subtitle}<p class="card-sub">{subtitle}</p>{/if}
      </div>
      {#if actions}<div class="acts">{@render actions()}</div>{/if}
    </header>
  {/if}
  <div class:card-pad={padded} class="body">{@render children()}</div>
  {#if footer}<footer class="foot">{@render footer()}</footer>{/if}
</section>

<style>
  .titles { min-width: 0; display: flex; flex-direction: column; gap: var(--space-0_5); }
  .acts { display: flex; align-items: center; gap: var(--space-1_5); flex-shrink: 0; }
  .body { min-width: 0; }
  .card-header + .body.card-pad { padding-top: var(--space-3); }
  .foot { border-top: 1px solid var(--border); padding: var(--space-3) var(--card-pad); }
</style>
